import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { PendingPage } from './pages/PendingPage';
import { navItems } from './data/navigation';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3farfjsqfpw55">
      <Routes data-id="element-1" data-mp="3fa89pae26y7h">
        <Route element={<Layout data-id="element-3" data-mp="3fb15xhfe65bd" />} data-id="element-2" data-mp="3fbt2ovkq6938">
          <Route path="/" element={<Home data-id="element-5" data-mp="2rknmugesbgsx" />} data-id="element-4" data-mp="3f8nd7f86p56z" />
          {navItems.map(item => <Route key={item.path} path={item.path} element={<PendingPage item={item} data-id="element-7" data-mp="2mmcd05ohp6ap" />} data-id="element-6" data-mp="2rl6tv22wcks6" />)}
          <Route path="*" element={<Home data-id="element-9" data-mp="31aqf2ee30qq7" />} data-id="element-8" data-mp="2mjpvbd7vxaer" />
        </Route>
      </Routes>
    </BrowserRouter>;
}